<template>
  <div :class="classes.content">
    <CardHeader :eventId="eventId" />
    <div :class="classes.wrapper" class="promo">
      <div :class="[classes.promoContent]">
        <EventNameFitted
          :class="[classes.eventName, 'event-name']"
          :eventId="eventId"
          alignment="flex-start"
          :minSize="8"
          :lineHeight="1"
        />

        <div :class="[classes.promo]">
          <TagMarquee
            :class="[classes.promoText, 'promoText']"
            tag="div"
            styleGroup=""
            :get="promoTextStyle.get"
            :set="promoTextStyle.set"
          >
            {{ promoText }}
          </TagMarquee>
        </div>
      </div>
      <Button
        :class="[classes.oddsButton]"
        :marketId="marketId"
        :option="option"
      />
    </div>
  </div>
</template>

<script lang="ts">
// TODO: Add Square Logos for betting market

// import PromoLogo from "./Logo.vue";
import { computed, defineComponent } from "vue";
import EventNameFitted from "../../EventNameFitted.vue";
import Button from "./Button.vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import {
  composeMarket,
  injectBetData
} from "@fresh8/ad-data-composition/src/betData";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { Brand } from "@fresh8/types/src";
import TagMarquee from "../../TagMarquee.vue";
import CardHeader from "../../CardHeader.vue";

const useStyles = createUseStyles({
  content: {
    display: "flex",
    flexDirection: "column",
    padding: "0px 5px 3px 5px",
    height: "inherit",
    border: props => `1px solid ${props.marketBorderColor || "#dcddf"}`,
    background: props => props.cardBackgroundColor,
    borderRadius: props => `${props.borderRadius}px`
  },
  wrapper: {
    display: "grid",
    gridTemplateColumns: "3fr minmax(20%, 64px)",
    height: "100%",
    justifyContent: "space-between",
    boxSizing: "border-box",
    gap: "4px"
  },
  promoContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    width: "226px"
  },
  promo: {
    flex: "1 1 0",
    minHeight: "0px",
    overflow: "hidden",
    boxSizing: "border-box",
    flexDirection: "column",
    display: "flex"
  },
  eventName: {
    display: "flex",
    boxSizing: "border-box",
    "&.event-name": {
      justifyContent: "center",
      alignItems: "flex-start"
    },
    "& div, & span": {
      fontSize: "9px",
      textAlign: "left"
    }
  },
  promoLogo: {
    width: "50%"
  },
  promoText: {
    display: "flex",
    boxSizing: "border-box",
    gridColumnStart: "1"
  },
  oddsButton: {
    gridColumnStart: "2",
    minWidth: "64px"
  }
});

export default defineComponent({
  name: "WideLeaderboardPromo",
  components: {
    CardHeader,
    EventNameFitted,
    Button,
    TagMarquee
  },
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup(props) {
    const brandContext = injectBrand();
    const classesRef = useStyles(
      computed(() => ({ ...brandContext?.adTemplateBranding.value }))
    );
    const { options } = injectBetData();

    const marketData = composeMarket(props.marketId);

    const option = computed(
      () => marketData.value && options.value?.[marketData.value.options[0]]
    );

    return {
      promoText: computed(() => option.value.promoText),
      promoTextStyle: {
        get(brand: Brand | undefined) {
          return brand?.adTemplate.market.promoTextFont;
        },
        set(brand: Brand, value: string) {
          brand.adTemplate.market.promoTextFont = value;
        }
      },
      classes: classesRef.value,
      marketData,
      option
    };
  }
});
</script>
